var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _c("div", { staticClass: "detail", on: { scroll: _vm.listenScroll } }, [
      _vm.pageType != "adminManager"
        ? _c("div", { staticClass: "tool df hao jcb" }, [
            _vm.isRule
              ? _c("div", { staticClass: "rule" }, [_vm._v("公告")])
              : _c("div"),
            _vm._v(" "),
            _vm.status == 2
              ? _c("div", { staticClass: "edit", on: { click: _vm.toEdit } }, [
                  _vm._v("修改问题")
                ])
              : _c(
                  "div",
                  {
                    staticClass: "follow",
                    class: { has: _vm.isFollow },
                    on: { click: _vm.follow }
                  },
                  [_vm._v(_vm._s(_vm.isFollow ? "已关注" : "关注问题"))]
                )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "txt", domProps: { innerHTML: _vm._s(_vm.txt) } },
        [_vm._v(_vm._s(_vm.txt))]
      ),
      _vm._v(" "),
      _vm.files.length > 0
        ? _c(
            "div",
            { staticClass: "file" },
            _vm._l(_vm.files, function(v, i) {
              return _c("div", { key: i, staticClass: "fileLi df" }, [
                _c("div", { staticClass: "fileName flex" }, [
                  _vm._v(_vm._s(v.name))
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "df wao hao",
                    on: {
                      click: function($event) {
                        return _vm.downloadFile(v)
                      }
                    }
                  },
                  [_vm._v("下载")]
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "end df hao" }, [
        _c(
          "div",
          {
            staticClass: "like",
            class: { has: _vm.isLike },
            on: { click: _vm.like }
          },
          [_vm._v(_vm._s(_vm.likeCount) + " 点赞")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "answer" }, [
          _vm._v(_vm._s(_vm.answerCount) + " 回答")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "user",
            on: {
              click: function($event) {
                return _vm.toUser(_vm.userId)
              }
            }
          },
          [_vm._v(_vm._s(_vm.user) + "（" + _vm._s(_vm.account) + "）")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))])
      ]),
      _vm._v(" "),
      _vm.relation.id != ""
        ? _c(
            "div",
            {
              staticClass: "relation ov-d",
              on: {
                click: function($event) {
                  return _vm.toDetail({ id: _vm.relation.id })
                }
              }
            },
            [_vm._v("原始问题：" + _vm._s(_vm.relation.title))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "handle df hao" }, [
        _c(
          "div",
          {
            staticClass: "answerBtn",
            class: { no: _vm.status == 2 },
            on: { click: _vm.toAnswer }
          },
          [_vm._v("写回答")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex df war hao" }, [
          _vm.isMode
            ? _c(
                "div",
                {
                  staticClass: "topBtn",
                  class: { has: _vm.type.indexOf("top") >= 0 },
                  on: {
                    click: function($event) {
                      _vm.openConfirm(
                        "top",
                        _vm.title,
                        _vm.type.indexOf("top") >= 0
                      )
                    }
                  }
                },
                [_vm._v("置顶")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMode
            ? _c(
                "div",
                {
                  staticClass: "prizeBtn",
                  class: { has: _vm.type.indexOf("prize") >= 0 },
                  on: {
                    click: function($event) {
                      _vm.openConfirm(
                        "prize",
                        _vm.title,
                        _vm.type.indexOf("prize") >= 0
                      )
                    }
                  }
                },
                [_vm._v("加精")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMode
            ? _c(
                "div",
                {
                  staticClass: "removeBtn",
                  on: {
                    click: function($event) {
                      return _vm.openConfirm("remove", _vm.title)
                    }
                  }
                },
                [_vm._v("删除")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.list, function(v, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "li",
              class: { "li-blue": v["creatorRoles"] === "teacher" }
            },
            [
              v.bestFlag === 1
                ? _c("div", { staticClass: "best" }, [
                    _c("img", {
                      staticStyle: { width: "0.16rem", height: "0.16rem" },
                      attrs: { src: require("@/app/assets/best.png") }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "bestTip" }, [
                      _vm._v("Best Answer 最佳答案")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "li-tool df hao" }, [
                _c(
                  "div",
                  {
                    staticClass: "li-user",
                    on: {
                      click: function($event) {
                        return _vm.toUser(v.creatorId)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(v.creatorName) +
                        "(" +
                        _vm._s(v.creatorMapperNumber) +
                        ")"
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.$h5Userid != v.creatorId
                  ? _c(
                      "div",
                      {
                        staticClass: "li-follow",
                        class: { has: v.attention > 0 },
                        on: {
                          click: function($event) {
                            return _vm.followItem(v.creatorId, v.attention, v)
                          }
                        }
                      },
                      [_vm._v(_vm._s(v.attention > 0 ? "已关注" : "关注"))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "flex" })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "li-txt",
                  domProps: { innerHTML: _vm._s(v.content) }
                },
                [_vm._v(_vm._s(v.content))]
              ),
              _vm._v(" "),
              v.files.length > 0
                ? _c(
                    "div",
                    { staticClass: "li-file" },
                    _vm._l(v.files, function(v2, i2) {
                      return _c(
                        "div",
                        { key: i2, staticClass: "li-fileLi df" },
                        [
                          _c("div", { staticClass: "li-fileName flex" }, [
                            _vm._v(_vm._s(v2.name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "df wao hao",
                              on: {
                                click: function($event) {
                                  return _vm.downloadFile(v2)
                                }
                              }
                            },
                            [_vm._v("下载")]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "li-end df hao jcb" }, [
                _c("div", { staticClass: "li-date" }, [
                  _vm._v(_vm._s(_vm.dateTime(v.createTime)))
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "li-like",
                      class: { has: v.approval > 0 },
                      on: {
                        click: function($event) {
                          return _vm.likeItem(v.id, v.approval, v)
                        }
                      }
                    },
                    [_vm._v(_vm._s(v.approvalTotal))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "li-collect",
                      class: { has: v.collection > 0 },
                      staticStyle: { "margin-left": "105px" },
                      on: {
                        click: function($event) {
                          return _vm.collectItem(v.id, v.collection, v)
                        }
                      }
                    },
                    [_vm._v(_vm._s(v.collection > 0 ? "已收藏" : "收藏"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "li-btn df war hao" }, [
                v.bestFlag !== 1 && _vm.isMode
                  ? _c(
                      "div",
                      {
                        staticClass: "bestBtn",
                        on: {
                          click: function($event) {
                            return _vm.setBestAnswer(v.id)
                          }
                        }
                      },
                      [_vm._v("Best Answer")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isMode
                  ? _c(
                      "div",
                      {
                        staticClass: "li-removeBtn",
                        on: {
                          click: function($event) {
                            return _vm.openConfirm("removeAns", "", "", v.id)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  : _vm._e()
              ])
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.collectBase.has
      ? _c("div", { staticClass: "collectBase" }, [
          _c("div", { staticClass: "collectBase-box" }, [
            _c("div", { staticClass: "collectBase-top" }, [
              _c("div", {
                staticClass: "collectBase-close",
                on: { click: _vm.closeCollectBase }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "已选择" + _vm._s(_vm.collectBase.choose.length) + "个收藏夹"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectBase-add",
                  on: { click: _vm.showCollectAddBase }
                },
                [_vm._v("新建收藏夹")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collectBase-list" },
              _vm._l(_vm.collectBase.list, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "collectBase-li df cf wao",
                    class: { cur: _vm.collectBase.choose.indexOf(i) >= 0 },
                    on: {
                      click: function($event) {
                        return _vm.chooseCollectBase(i)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "collectBase-title" }, [
                      _vm._v(_vm._s(v.name))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "collectBase-answer" }, [
                      _vm._v(_vm._s(v.answerTotal) + "个回答")
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collectBase-btn",
                on: { click: _vm.resCollectBase }
              },
              [_vm._v("确认")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.collectAddBase.has
      ? _c("div", { staticClass: "collectAddBase df wao hao" }, [
          _c("div", { staticClass: "collectAddBase-box" }, [
            _c("div", { staticClass: "collectAddBase-input df hao" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.collectAddBase.val,
                    expression: "collectAddBase.val"
                  }
                ],
                staticClass: "flex",
                attrs: { type: "text", puc: "", placeholder: "输入收藏夹标题" },
                domProps: { value: _vm.collectAddBase.val },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.collectAddBase, "val", $event.target.value)
                    },
                    _vm.checkInput
                  ]
                }
              }),
              _vm._v(" "),
              _c("i", [_vm._v(_vm._s(13 - _vm.collectAddBase.val.length))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "collectAddBase-end df war hao" }, [
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.resCollectAddBase }
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.closeCollectAddBase }
                },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.confirm.has
      ? _c("div", { staticClass: "confirm df wao hao" }, [
          _c("div", { staticClass: "confirm-box" }, [
            _vm.confirm.type == "top"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认对“"),
                  _c(
                    "div",
                    {
                      staticClass: "ov-d",
                      class: { flex: _vm.confirm.txt.length > 6 }
                    },
                    [_vm._v(_vm._s(_vm.confirm.txt))]
                  ),
                  _vm._v("”该问题"),
                  _c("em", [
                    _vm._v(
                      _vm._s(_vm.confirm.state == 2 ? "取消" : "") + "置顶"
                    )
                  ]),
                  _vm._v("操作吗？")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.confirm.type == "topAns"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认对该回答"),
                  _c("em", [
                    _vm._v(
                      _vm._s(_vm.confirm.state == 2 ? "取消" : "") + "置顶"
                    )
                  ]),
                  _vm._v("操作吗？")
                ])
              : _vm.confirm.type == "prize"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认对“"),
                  _c(
                    "div",
                    {
                      staticClass: "ov-d",
                      class: { flex: _vm.confirm.txt.length > 6 }
                    },
                    [_vm._v(_vm._s(_vm.confirm.txt))]
                  ),
                  _vm._v("”该问题"),
                  _c("em", [
                    _vm._v(
                      _vm._s(_vm.confirm.state == 2 ? "取消" : "") + "加精"
                    )
                  ]),
                  _vm._v("操作吗？")
                ])
              : _vm.confirm.type == "remove"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认对“"),
                  _c(
                    "div",
                    {
                      staticClass: "ov-d",
                      class: { flex: _vm.confirm.txt.length > 6 }
                    },
                    [_vm._v(_vm._s(_vm.confirm.txt))]
                  ),
                  _vm._v("”该问题"),
                  _c("em", [_vm._v("删除")]),
                  _vm._v("操作吗？")
                ])
              : _vm.confirm.type == "archive"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认将该回答进行"),
                  _c("em", [_vm._v("归档")]),
                  _vm._v("操作吗？")
                ])
              : _vm.confirm.type == "removeAns"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认"),
                  _c("em", [_vm._v("删除")]),
                  _vm._v("该回答吗？")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-end df war hao" }, [
              _vm.confirm.type == "top"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.confirm.state == 2 ? "取消" : "确定") +
                          "置顶"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.confirm.type == "topAns"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.confirm.state == 2 ? "取消" : "确定") +
                          "置顶"
                      )
                    ]
                  )
                : _vm.confirm.type == "prize"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.confirm.state == 2 ? "取消" : "确定") +
                          "加精"
                      )
                    ]
                  )
                : _vm.confirm.type == "remove"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [_vm._v("确定删除")]
                  )
                : _vm.confirm.type == "archive"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [_vm._v("确定归档")]
                  )
                : _vm.confirm.type == "removeAns"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [_vm._v("确定删除")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "confirm-btn", on: { click: _vm.closeConfirm } },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-042e3527", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042e3527","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/model/detail/detail.vue
// module id = null
// module chunks = 